import { Component } from '@theme/component';

/**
 * @property {HTMLAnchorElement|HTMLButtonElement} button - The clickable element
 */
class EscFilterControl extends Component {
  requiredRefs = ['button'];

  get sectionId() {
    const id = this.getAttribute('section-id');
    if (!id) throw new Error('Section ID is required');
    return id;
  }

  get section() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  /** @type {Element|null} */
  #prefetchedSection = null

  connectedCallback() {
    super.connectedCallback();

    this.#addListeners() 
  }

  #addListeners() {
    this.refs.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.#toggleFilter();
    });

    this.addEventListener('mouseover', () => {
      this.#prefetch();
    })
  }

  #toggleFilter() {
    if (!this.section || !this.dataset.href) {
      return;
    }

    if (this.#prefetchedSection) {
      history.replaceState('', '', new URL(this.dataset.href, `${window.location.protocol}//${window.location.host}`));
      this.section.innerHTML = this.#prefetchedSection.innerHTML;
      this.#prefetch();
    } else {
      this.#prefetch().then(() => this.#toggleFilter());
    }
  }

  #prefetch() {
    if (!this.dataset.href) {
      throw new Error('HREF is required');
    }

    const url = new URL(this.dataset.href, `${window.location.protocol}//${window.location.host}`);

    return fetch(url)
      .then((response) => response.text())
      .then((responseHTML) => {
        const wrapper = document.createElement("div")
        wrapper.innerHTML = responseHTML;

        this.#prefetchedSection = wrapper.querySelector(`#shopify-section-${this.sectionId}`);
      })
  }
}

if (!customElements.get('esc-filter-control')) {
  	customElements.define('esc-filter-control', EscFilterControl);
}